import { useAuth } from '@/lib/store';
import { LoginPage } from '@/pages/LoginPage';
import { Layout } from '@/components/layout/Layout';
import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { initializeAnalytics, identifyUser } from '@/lib/utils/analytics';

// Initialize analytics once at app startup
initializeAnalytics();

export default function App() {
  const { isAuthenticated, username } = useAuth((state) => ({
    isAuthenticated: state.isAuthenticated,
    username: state.username
  }));

  // Identify user on app load if authenticated
  useEffect(() => {
    if (isAuthenticated && username) {
      identifyUser(username);
    }
  }, [isAuthenticated, username]);

  return (
    <ThemeProvider>
      <BrowserRouter>
        {!isAuthenticated ? <LoginPage /> : <Layout />}
      </BrowserRouter>
    </ThemeProvider>
  );
}